import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];

const minutesAgo = (nowSeconds, dateSeconds) => {
    return ((nowSeconds - dateSeconds) / 60).toFixed(0);
};

const hoursAgo = (nowSeconds, dateSeconds) => {
    return Math.ceil((nowSeconds - dateSeconds) / 60 / 60).toFixed(0);
};

const fromNow = date => {
    const now = new Date();
    const nowSeconds = now.getTime() / 1000;
    const dateSeconds = date.getTime() / 1000;
    // get diff between now and the date in seconds
    const dateDiff = nowSeconds - dateSeconds;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayTimeSeconds = today.getTime() / 1000;

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    const yesterdayTimeSeconds = yesterday.getTime() / 1000;

    // get diff between now and the beginning of the year in seconds
    const start = new Date(now.getFullYear(), 0, 0);
    const yearDiff = (now - start) / 1000;

    switch (true) {
        case dateDiff < 60:
            return 'Just now';
        case dateDiff < 60 * 60:
            return `${minutesAgo(nowSeconds, dateSeconds)} minutes ago`;
        case dateDiff < 60 * 60 * 12:
            return `${hoursAgo(nowSeconds, dateSeconds)} hours ago`;
        case dateDiff < 60 * 60 * 24 && todayTimeSeconds < dateSeconds:
            return 'Today';
        case dateDiff < 60 * 60 * 24 * 2 && yesterdayTimeSeconds < dateSeconds:
            return 'Yesterday';
        case dateDiff < 60 * 60 * 24 * 6:
            return days[date.getDay()];
        case dateDiff < yearDiff:
            return date.toDateString().substr(4, 6);
        default:
            return date.toDateString().substr(4);
    }
};

const AssetDate = ({ date }) => {
    return <Typography variant="caption">{fromNow(date)}</Typography>;
};

AssetDate.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
};

export default AssetDate;



// WEBPACK FOOTER //
// ./src/components/assets/AssetDate.js